/* ────────────────────────────────────────────────────────────────
   MOCK DATA — remove once your real endpoints are wired everywhere.
   Kept here only as an initial/fallback state so screens aren't
   empty while the first request is in flight.
   ──────────────────────────────────────────────────────────────── */
export const MOCK_PLANS = [
  { id: 'plan_starter', name: 'Starter', price: 29, cycle: 'monthly', status: 'active',
    features: ['5 seats', '10 GB storage', 'Email support'] },
  { id: 'plan_growth', name: 'Growth', price: 99, cycle: 'monthly', status: 'active',
    features: ['25 seats', '100 GB storage', 'Priority support', 'API access'] },
  { id: 'plan_enterprise', name: 'Enterprise', price: 499, cycle: 'monthly', status: 'active',
    features: ['Unlimited seats', '1 TB storage', 'Dedicated support', 'SSO', 'Custom SLA'] },
  { id: 'plan_legacy', name: 'Legacy Pro', price: 79, cycle: 'monthly', status: 'inactive',
    features: ['15 seats', '50 GB storage'] },
];

export const MOCK_ORGS = [
  { org_id: 'org_001', org_name: 'Northwind Logistics', plan_name: 'Growth', status: 'active', started_at: '2025-11-02', renews_at: '2026-11-02', mrr: 99 },
  { org_id: 'org_002', org_name: 'Solstice Analytics', plan_name: 'Enterprise', status: 'active', started_at: '2025-06-15', renews_at: '2026-06-15', mrr: 499 },
  { org_id: 'org_003', org_name: 'Fernbridge Studio', plan_name: 'Starter', status: 'trial', started_at: '2026-08-01', renews_at: '2026-08-15', mrr: 0, trial_ends_at: '2026-08-15' },
  { org_id: 'org_004', org_name: 'Kettlewell & Co', plan_name: 'Growth', status: 'pending', started_at: '2026-08-10', renews_at: null, mrr: 99 },
  { org_id: 'org_005', org_name: 'Alderbrook Health', plan_name: 'Starter', status: 'suspended', started_at: '2025-01-20', renews_at: '2026-01-20', mrr: 29 },
  { org_id: 'org_006', org_name: 'Pinegate Foods', plan_name: 'Enterprise', status: 'cancelled', started_at: '2024-09-11', renews_at: null, mrr: 0 },
];

export const mockOrgDetail = (org) => ({
  subscription: org,
  trial: org.status === 'trial'
    ? { started_at: org.started_at, ends_at: org.trial_ends_at, days_left: 3 }
    : null,
  access_cache: {
    last_synced: '2026-08-12T04:11:00Z',
    features_enabled: org.plan_name === 'Enterprise'
      ? ['sso', 'api_access', 'priority_support', 'custom_sla']
      : org.plan_name === 'Growth'
      ? ['api_access', 'priority_support']
      : ['email_support'],
  },
});

export const mockLogs = (org) => ([
  { timestamp: '2026-08-10T09:14:00Z', action: 'PLAN_ASSIGNED', actor: 'superadmin@ops.io', details: `Assigned ${org.plan_name} plan` },
  { timestamp: '2026-07-02T14:02:00Z', action: 'SUBSCRIPTION_RENEWED', actor: 'system', details: 'Auto-renewal processed' },
  { timestamp: '2026-06-01T11:45:00Z', action: 'STATUS_CHANGED', actor: 'superadmin@ops.io', details: `Status set to ${org.status}` },
]);

export const mockInvoices = (org) => ([
  { invoice_id: 'INV-8831', date: '2026-08-01', amount: org.mrr, status: org.mrr ? 'paid' : 'n/a', plan_name: org.plan_name },
  { invoice_id: 'INV-8710', date: '2026-07-01', amount: org.mrr, status: org.mrr ? 'paid' : 'n/a', plan_name: org.plan_name },
  { invoice_id: 'INV-8592', date: '2026-06-01', amount: org.mrr, status: org.mrr ? 'paid' : 'n/a', plan_name: org.plan_name },
]);

/* ────────────────────────────────────────────────────────────────
   STATUS STYLES + FORMATTERS
   ──────────────────────────────────────────────────────────────── */
export const STATUS_STYLE = {
  active:    { color: '#16A34A', label: 'Active' },
  trial:     { color: '#9333EA', label: 'Trial' },
  pending:   { color: '#2563EB', label: 'Pending' },
  suspended: { color: '#DC2626', label: 'Suspended' },
  cancelled: { color: '#8B8698', label: 'Cancelled' },
  inactive:  { color: '#8B8698', label: 'Inactive' },
};

export const fmtMoney = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 0 })}`;

export const fmtDate = (d) =>
  d ? new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }) : '—';

export const fmtDateTime = (d) =>
  d ? new Date(d).toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';
